import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { NotyService } from '../../../services/common/noty.service';
import { PaymentObligationService } from '../../../services/accounting/payment-obligation.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-payment-obligation-index',
  templateUrl: './payment-obligation-index.component.html',
  styleUrls: ['./payment-obligation-index.component.scss'],
})
export class PaymentObligationIndexComponent implements OnInit {
  allSelect: boolean = false;

  creatingPayment: boolean = false;

  loading: boolean = true;

  obligations: Array<any> = [];

  paymentChecks: Array<any> = [];

  preparingPayment: boolean = false;

  preparedPayments: Array<any> = [];

  paymentNgbModalRef: NgbModalRef | null;

  @ViewChild('paymentModal', { static: true }) paymentModalTemplate: TemplateRef<any>;

  constructor(private modalService: NgbModal, private notyService: NotyService, private paymentObligationService: PaymentObligationService, private userService: UserService) {}

  // Component lifecycle methods
  ngOnInit() {
    //this.userService.navbarComponent.setPaymentsMenu();
    this.paymentObligationService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.obligations = response_json.obligations;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  // Component methods
  allSelectToggle() {
    for (let obligation of this.obligations) {
      obligation.selected = this.allSelect;
      for (let paymentObligation of obligation.payment_obligations) paymentObligation.selected = this.allSelect;
    }
  }

  calculateTotal() {
    for (let check of this.paymentChecks) {
      let total: number = 0;
      for (let chartOfAccount of check.data.chart_of_accounts) total += chartOfAccount.amount;
      check.total = total;
    }
  }

  createPayment() {
    this.creatingPayment = true;
    this.paymentObligationService
      .createPayment(this.paymentChecks)
      .then((response_json) => {
        this.creatingPayment = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Payments successful', 'success');
          if (this.paymentNgbModalRef) {
            this.paymentNgbModalRef.close();
            this.paymentNgbModalRef = null;
          }
          setTimeout(() => {
            if (response_json.entry_group_id) window.location.href = `/entry_groups/${response_json.entry_group_id}`;
          }, 1000);
        } else this.notyService.notify(response_json.text || 'Error creating payment', 'error');
      })
      .catch(() => {
        this.creatingPayment = false;
        this.notyService.notify('Error creating payment', 'error');
      });
  }

  preparePayment() {
    let chart_of_account_ids: Array<number> = [];
    let payment_obligation_ids: Array<number> = [];
    for (let obligation of this.obligations)
      if (obligation.selected) {
        chart_of_account_ids.push(obligation.chart_of_account_id);
        for (let paymentObligation of obligation.payment_obligations) if (paymentObligation.selected) payment_obligation_ids.push(paymentObligation.id);
      }
    if (chart_of_account_ids.length < 1 && payment_obligation_ids.length < 1) this.notyService.notify('No obligation selected', 'error');
    else {
      this.preparingPayment = true;
      this.paymentObligationService
        .preparePayment(chart_of_account_ids, payment_obligation_ids)
        .then((response_json) => {
          try {
            this.preparingPayment = false;
            if (response_json.success) {
              this.paymentChecks = response_json.checks;
              this.calculateTotal();
              this.paymentNgbModalRef = this.modalService.open(this.paymentModalTemplate);
              this.paymentNgbModalRef.result.then(
                (result) => {},
                (reason) => {}
              );
            } else this.notyService.notify(response_json.text || 'Error preparing payment', 'error');
          } catch (err) {
            console.error(err);
          }
        })
        .catch(() => {
          this.preparingPayment = false;
          this.notyService.notify('Error preparing payment', 'error');
        });
    }
  }
}
